'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	MINECRAFT: {
		COLUMNS: [
			{
				TITLE: 'Watch',
				EXPLANATION: 'Our easy to follow videos teach you how to code step by step',
				ANIMATION: 'HowItWorksWatch'
			},
			{
				TITLE: 'Code',
				EXPLANATION: 'Our web based code editor gives you everything you need to start coding',
				ANIMATION: 'HowItWorksCode'
			},
			{
				TITLE: 'Play',
				EXPLANATION: 'Build then run your games on your own private Minecraft server',
				ANIMATION: 'HowItWorksPlay'
			}
		]
	},
	ROBLOX: {
		COLUMNS: [
			{
				TITLE: 'Watch',
				EXPLANATION: 'Our easy to follow videos teach you how to code step by step',
				ANIMATION: 'HowItWorksWatch'
			},
			{
				TITLE: 'Code',
				EXPLANATION: 'Our web based code editor gives you everything you need to start coding',
				ANIMATION: 'HowItWorksCode'
			},
			{
				TITLE: 'Play',
				EXPLANATION: 'Build then publish your games and share them with friends',
				ANIMATION: 'HowItWorksPlay'
			}
		]
	},
	EDUCATORS: {
		COLUMNS: [
			{
				TITLE: 'Ready-­to-­use curriculum',
				EXPLANATION: '80+ hours of teacher­-designed camp courses',
				IMAGE: 'educators-how-it-works-1'
			},
			{
				TITLE: 'Leading software',
				EXPLANATION: 'Students drag and drop code to build their own games and mods',
				IMAGE: 'educators-how-it-works-2'
			},
			{
				TITLE: 'Take-­home projects',
				EXPLANATION: 'Students take home camp projects to share achievements with parents',
				IMAGE: 'educators-how-it-works-3'
			}
		]
	},
	SCHOOLS: {
		COLUMNS: [
			{
				TITLE: 'Ready-­to-­use curriculum',
				EXPLANATION: '80+ hours of curriculum-mapped programming courses',
				IMAGE: 'educators-how-it-works-1'
			},
			{
				TITLE: 'Leading software',
				EXPLANATION: 'Real programming languages and real games, not pseudo code',
				IMAGE: 'educators-how-it-works-2'
			},
			{
				TITLE: 'Automatic Assessment',
				EXPLANATION: 'Our software automatically checks and reports student progress',
				IMAGE: 'educators-how-it-works-3'
			}
		]
	},
	GENERIC: {
		COLUMNS: [
			{
				TITLE: 'Watch',
				EXPLANATION: 'Our easy to follow videos teach you how to code step by step',
				ANIMATION: 'HowItWorksWatch'
			},
			{
				TITLE: 'Code',
				EXPLANATION: 'Our web based code editor gives you everything you need to start coding',
				ANIMATION: 'HowItWorksCode'
			},
			{
				TITLE: 'Play',
				EXPLANATION: 'Build then publish your games and share them with friends',
				ANIMATION: 'HowItWorksPlay'
			}
		]
	},
	TITLE: 'How it works'
});
